"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EStateActionTypes = void 0;
let EStateActionTypes = exports.EStateActionTypes = /*#__PURE__*/function (EStateActionTypes) {
  EStateActionTypes["SetState"] = "state/setState";
  EStateActionTypes["ResetStateToPhoneAuth"] = "state/resetToPhoneAuth";
  EStateActionTypes["ResetStateToUsernameAuth"] = "state/resetToUsernameAuth";
  EStateActionTypes["ChangeStateToPhoneAuth"] = "state/changeToPhoneAuth";
  EStateActionTypes["ChangeStateToUsernameAuth"] = "state/changeToUsernameAuth";
  return EStateActionTypes;
}({});